import { minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import {
  mediaQuery,
  pxToRem,
  responsiveFontSize,
  shadowUp,
  stack,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text, colors, fonts } = theme;

export const noSearchResultsWrapper = css`
  text-align: center;
  padding-top: ${pxToRem(spacing.xxxxl)};
  margin: ${stack(spacing.xl)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      ${shadowUp};
    `,
  )};
`;

export const heading = css``;

export const headingText = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  font-size: ${text.sm.SMALL.fontSize}px;
  line-height: ${text.sm.SMALL.lineHeight}px;
  color: ${colors.neutralDark};
  display: block;
`;

export const headingTerm = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${responsiveFontSize(text.xxl)};
  display: block;
`;

export const info = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  font-size: ${text.sm.SMALL.fontSize}px;
  margin-top: ${pxToRem(spacing.xxxl)};
`;
